import i18n from 'src/app/i18n';
import { brand, neutrals } from 'src/theme/colors';
import { ILLUSTRATION_NAMES } from '../illustration/illustration.helper';
import { ARROW_POSITIONS } from './Tutorial.types';

export const TUTORIALS_DESKTOP = {
  ProductToolbar: [
    {
      stepId: 'step-1',
      targetArea: 'firstProductArea',
      tutorialCard: {
        illustration: ILLUSTRATION_NAMES.PicAI,
        text: i18n.t('tutorial:product-text'),
        ctaText: i18n.t('tutorial:product-cta'),
      },
      arrow: {
        strokeColor: brand.main.water,
        strokeWidth: 3,
        arrowSize: 20,
        curvature: 0.6,
        startSide: ARROW_POSITIONS.LEFT,
        endSide: ARROW_POSITIONS.TOP,
        startOffset: 30,
        endOffset: 30,
      },
      onPressNext: 'selectFirstProduct',
      withBackground: true,
    },
    {
      stepId: 'step-2',
      targetArea: 'toolbarArea',
      tutorialCard: {
        illustration: ILLUSTRATION_NAMES.Exit2,
        text: i18n.t('tutorial:toolbar-text'),
        ctaText: i18n.t('tutorial:toolbar-cta'),
      },
      arrow: {
        strokeColor: brand.main.water,
        strokeWidth: 3,
        arrowSize: 20,
        curvature: 0.6,
        startSide: ARROW_POSITIONS.LEFT,
        endSide: ARROW_POSITIONS.TOP,
        startOffset: 30,
        endOffset: 30,
      },
      onPressNext: 'closeTutorial',
      withBackground: true,
    },
  ],
  SliderZoom: [
    {
      stepId: 'step-1',
      targetArea: 'sliderZoomArea',
      tutorialCard: {
        illustration: ILLUSTRATION_NAMES.ZoomIn,
        text: i18n.t('tutorial:zoom-text'),
        ctaText: i18n.t('tutorial:zoom-cta'),
        backgroundColor: neutrals.white,
      },
      arrow: {
        strokeColor: brand.main.water,
        strokeWidth: 3,
        arrowSize: 20,
        curvature: -0.6,
        startSide: ARROW_POSITIONS.LEFT,
        endSide: ARROW_POSITIONS.BOTTOM,
        startOffset: 30,
        endOffset: 30,
      },
      onPressNext: 'closeTutorial',
      withBackground: false,
    },
  ],
};

export const TUTORIALS_MOBILE = {
  ProductToolbar: [
    {
      stepId: 'step-1',
      targetArea: 'firstProductArea',
      tutorialCard: {
        illustration: ILLUSTRATION_NAMES.PicAI,
        text: i18n.t('tutorial:product-text'),
        ctaText: i18n.t('tutorial:product-cta'),
      },
      arrow: {
        strokeColor: brand.main.water,
        strokeWidth: 3,
        arrowSize: 20,
        curvature: 0.6,
        startSide: ARROW_POSITIONS.BOTTOM,
        endSide: ARROW_POSITIONS.TOP,
        startOffset: -20,
        endOffset: -20,
      },
      onPressNext: 'selectFirstProduct',
      withBackground: true,
    },
    {
      stepId: 'step-2',
      targetArea: 'toolbarAreaMobile',
      tutorialCard: {
        illustration: ILLUSTRATION_NAMES.Exit2,
        text: i18n.t('tutorial:toolbar-text'),
        ctaText: i18n.t('tutorial:toolbar-cta'),
        backgroundColor: neutrals.white,
      },
      arrow: {
        strokeColor: brand.main.water,
        strokeWidth: 3,
        arrowSize: 20,
        curvature: 0.6,
        startSide: ARROW_POSITIONS.BOTTOM,
        endSide: ARROW_POSITIONS.TOP,
        startOffset: -20,
        endOffset: -20,
      },
      onPressNext: 'closeTutorial',
      withBackground: true,
    },
  ],
  SliderZoom: [
    {
      stepId: 'step-1',
      targetArea: 'sliderZoomArea',
      tutorialCard: {
        illustration: ILLUSTRATION_NAMES.PointingHand,
        text: i18n.t('tutorial:zoom-text-mobile'),
        ctaText: i18n.t('tutorial:zoom-cta'),
      },
      arrow: {
        strokeColor: brand.main.water,
        strokeWidth: 3,
        arrowSize: 20,
        curvature: 0.6,
        startSide: ARROW_POSITIONS.BOTTOM,
        endSide: ARROW_POSITIONS.LEFT,
        startOffset: -30,
        endOffset: -30,
      },
      onPressNext: 'closeTutorial',
      withBackground: false,
    },
  ],
};
